import './index.css'

import logo from './logo.svg'
import { animate, easeIn, easeOut } from 'popmotion'
import { getQueryParams, upsertMetatag } from '../utils'
import { decodeStateFromUrl } from './decode'

async function render (state) {
  const {
    youtubeUrl, youtubeImageUrl, youtubeTrackName, audio,
    slowControl, reverbMode, lowPassMode, lofiTapeMode, videoFx,
    mediaId, error, embeded, playAudio
  } = state

  if (error) {
    document.getElementById('content').innerHTML = 'Error'
    return
  }

  if (!youtubeUrl) {
    document.getElementById('content').innerHTML = 'No video found'
    return
  }

  const playButton = `<div class="play">
    <div class="play__button">
      Play
    </div>
  </div>`

  const player = `
    <div id="play" class="thumbnail" style="${embeded && 'margin: 0'}">
      ${audio && audio.paused ? playButton : ''} 
      <div class="thumbnail__fx">
      </div>
      <img src="${youtubeImageUrl}" />
    </a>
  `

  let html

  if (embeded) {
    html = player
  } else {
    html = `
      <div class="share-container">
        <div class="container">
          <div class="share-logo logo">
            <img src="${logo}" />
          </div>

          <div class="title">
            ${youtubeTrackName}
          </div>

          <div class="media">
            <div class="media__sidebar">
              <div class="settings">
                <div class="settings__item ${slowControl < 1.0 ? 'settings__item--enabled' : ''}">
                  <div class="settings__item__icon">
                    <!-- <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 9.5C4 8.67157 4.67157 8 5.5 8C6.32843 8 7 8.67157 7 9.5V14.5C7 15.3284 6.32843 16 5.5 16C4.67157 16 4 15.3284 4 14.5V9.5Z" fill="currentColor"/>
                      <path d="M16.3077 8.5C16.3077 7.67157 16.9793 7 17.8077 7C18.6361 7 19.3077 7.67157 19.3077 8.5V15.5C19.3077 16.3284 18.6361 17 17.8077 17C16.9793 17 16.3077 16.3284 16.3077 15.5V8.5Z" fill="currentColor"/>
                      <path d="M10.1538 5.5C10.1538 4.67157 10.8254 4 11.6538 4C12.4823 4 13.1538 4.67157 13.1538 5.5V18.5C13.1538 19.3284 12.4823 20 11.6538 20C10.8254 20 10.1538 19.3284 10.1538 18.5V5.5Z" fill="currentColor"/>
                    </svg> -->
                  </div>
                  <div class="settings__item__value">
                    Slow Control
                  </div>
                  <div class="settings__item__state">
                    ${slowControl}×
                  </div>
                </div>
                
                <div class="settings__item ${reverbMode !== 'default' ? 'settings__item--enabled' : ''}">
                  <div class="settings__item__icon">
                    <!-- <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0139 20.5076C14.8441 20.5076 17.1385 18.2132 17.1385 15.383C17.1385 12.5527 14.8441 10.2584 12.0139 10.2584C9.18363 10.2584 6.88924 12.5527 6.88924 15.383C6.88924 18.2132 9.18363 20.5076 12.0139 20.5076ZM12.0139 22.4087C15.894 22.4087 19.0396 19.2632 19.0396 15.383C19.0396 11.5028 15.894 8.35729 12.0139 8.35729C8.1337 8.35729 4.98817 11.5028 4.98817 15.383C4.98817 19.2632 8.1337 22.4087 12.0139 22.4087Z" fill="currentColor"/>
                      <path d="M15.0414 11.0543C15.4126 10.6831 16.0145 10.6831 16.3857 11.0543C16.7569 11.4256 16.7569 12.0274 16.3857 12.3986L12.7491 16.0352C12.3779 16.4064 11.7761 16.4064 11.4049 16.0352C11.0337 15.664 11.0337 15.0621 11.4049 14.6909L15.0414 11.0543Z" fill="currentColor"/>
                      <path d="M18.199 4.34263C18.554 3.98756 19.1297 3.98756 19.4848 4.34263C19.8398 4.69769 19.8398 5.27337 19.4848 5.62845L17.6207 7.49249C17.2657 7.84753 16.69 7.84753 16.3349 7.49249C15.9799 7.1374 15.9799 6.56175 16.3349 6.20666L18.199 4.34263Z" fill="currentColor"/>
                      <path d="M5.80105 4.34263C5.44599 3.98756 4.87031 3.98756 4.51524 4.34263C4.16017 4.69769 4.16017 5.27337 4.51524 5.62845L6.37926 7.49249C6.73435 7.84753 7.31005 7.84753 7.66509 7.49249C8.02018 7.1374 8.02018 6.56175 7.66509 6.20666L5.80105 4.34263Z" fill="currentColor"/>
                      <path d="M11.1047 4.79429C11.1047 5.29643 11.5117 5.70352 12.0139 5.70352C12.516 5.70352 12.9231 5.29643 12.9231 4.79429V2.15815C12.9231 1.656 12.516 1.24894 12.0139 1.24894C11.5117 1.24894 11.1047 1.656 11.1047 2.15815V4.79429Z" fill="currentColor"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M16.4019 12.7344C16.3579 12.6617 16.3121 12.5901 16.2646 12.5197L12.7491 16.0352C12.3779 16.4064 11.7761 16.4064 11.4049 16.0352C11.0337 15.664 11.0337 15.0621 11.4049 14.6909L14.9284 11.1673C14.8588 11.1191 14.788 11.0726 14.7159 11.0278C13.9315 10.54 13.0056 10.2584 12.0139 10.2584C9.18363 10.2584 6.88924 12.5527 6.88924 15.383C6.88924 18.2132 9.18363 20.5076 12.0139 20.5076C14.8441 20.5076 17.1385 18.2132 17.1385 15.383C17.1385 14.4138 16.8694 13.5074 16.4019 12.7344ZM14.5349 11.2088C13.7993 10.7636 12.9365 10.5073 12.0139 10.5073C9.32111 10.5073 7.13818 12.6902 7.13818 15.383C7.13818 18.0757 9.32111 20.2587 12.0139 20.2587C14.7066 20.2587 16.8896 18.0757 16.8896 15.383C16.8896 14.4829 16.6456 13.6397 16.2203 12.916L12.9252 16.2112C12.4567 16.6796 11.6973 16.6796 11.2288 16.2112C10.7604 15.7428 10.7604 14.9833 11.2288 14.5149L14.5349 11.2088ZM18.0229 4.1666C18.4752 3.71432 19.2085 3.71432 19.6608 4.1666C20.1131 4.61888 20.1131 5.35217 19.6608 5.80447L17.7968 7.66851C17.3445 8.12076 16.6112 8.12077 16.1589 7.66852C15.7067 7.21622 15.7066 6.48295 16.1589 6.03065L18.0229 4.1666ZM19.4848 4.34263C19.1297 3.98756 18.554 3.98756 18.199 4.34263L16.3349 6.20666C15.9799 6.56175 15.9799 7.1374 16.3349 7.49249C16.69 7.84753 17.2657 7.84753 17.6207 7.49249L19.4848 5.62845C19.8398 5.27337 19.8398 4.69769 19.4848 4.34263ZM4.33921 5.80447C3.88693 5.35218 3.88693 4.61888 4.33921 4.1666C4.7915 3.71432 5.5248 3.71431 5.97708 4.1666L7.84112 6.03064C8.29342 6.48294 8.29342 7.21621 7.84112 7.66851C7.38885 8.12078 6.65554 8.12077 6.20325 7.66852L4.33921 5.80447ZM19.2885 15.383C19.2885 19.4006 16.0315 22.6576 12.0139 22.6576C7.99622 22.6576 4.73924 19.4006 4.73924 15.383C4.73924 11.3653 7.99622 8.10835 12.0139 8.10835C16.0315 8.10835 19.2885 11.3653 19.2885 15.383ZM12.0139 5.95246C11.3742 5.95246 10.8557 5.43391 10.8557 4.79429V2.15815C10.8557 1.51852 11.3743 1 12.0139 1C12.6535 1 13.172 1.51852 13.172 2.15815V4.79429C13.172 5.43391 12.6535 5.95246 12.0139 5.95246ZM12.0139 5.70352C11.5117 5.70352 11.1047 5.29643 11.1047 4.79429V2.15815C11.1047 1.656 11.5117 1.24894 12.0139 1.24894C12.516 1.24894 12.9231 1.656 12.9231 2.15815V4.79429C12.9231 5.29643 12.516 5.70352 12.0139 5.70352ZM12.0139 22.4087C15.894 22.4087 19.0396 19.2632 19.0396 15.383C19.0396 11.5028 15.894 8.35729 12.0139 8.35729C8.1337 8.35729 4.98817 11.5028 4.98817 15.383C4.98817 19.2632 8.1337 22.4087 12.0139 22.4087Z" fill="currentColor"/>
                      </svg> -->         
                  </div>
                  <div class="settings__item__value">
                    Reverb Mode
                  </div>
                  <div class="settings__item__state">
                    ${reverbMode}
                  </div>
                </div>

                <div class="settings__item ${videoFx ? 'settings__item--enabled' : ''}">
                  <div class="settings__item__icon">
                    <!-- <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.33375 6.75992C8.72042 6.79992 8.27375 6.98659 7.99375 7.31992C7.71375 7.65325 7.57375 8.13325 7.57375 8.75992V9.21992H9.27375C10.0204 9.21992 10.3938 9.53325 10.3938 10.1599C10.3938 10.7866 10.0204 11.0999 9.27375 11.0999H7.57375V17.9199C7.57375 18.3066 7.45375 18.5999 7.21375 18.7999C6.98708 18.9999 6.69375 19.0999 6.33375 19.0999C5.97375 19.0999 5.67375 18.9999 5.43375 18.7999C5.19375 18.5999 5.07375 18.3066 5.07375 17.9199V11.0999H4.07375C3.32708 11.0999 2.95375 10.7866 2.95375 10.1599C2.95375 9.53325 3.32708 9.21992 4.07375 9.21992H5.07375V9.07992C5.07375 7.82659 5.40042 6.84659 6.05375 6.13992C6.72042 5.41992 7.65375 5.01325 8.85375 4.91992L9.37375 4.87992C9.90708 4.83992 10.2804 4.89992 10.4938 5.05992C10.7204 5.20659 10.8338 5.43992 10.8338 5.75992C10.8338 6.33325 10.5071 6.65325 9.85375 6.71992L9.33375 6.75992Z" fill="currentColor"/>
                      <path d="M20.0417 17.1599C20.2817 17.3999 20.4017 17.6733 20.4017 17.9799C20.4017 18.2733 20.2884 18.5399 20.0617 18.7799C19.8351 19.0066 19.5684 19.1199 19.2617 19.1199C18.9284 19.1199 18.6417 18.9799 18.4017 18.6999L15.5817 15.5799L12.7617 18.6999C12.5084 18.9666 12.2217 19.0999 11.9017 19.0999C11.6084 19.0999 11.3484 18.9866 11.1217 18.7599C10.8951 18.5333 10.7817 18.2733 10.7817 17.9799C10.7817 17.6733 10.9017 17.3999 11.1417 17.1599L14.0617 13.9799L11.3017 10.9799C11.0617 10.7399 10.9417 10.4666 10.9417 10.1599C10.9417 9.85325 11.0551 9.59325 11.2817 9.37992C11.5084 9.15325 11.7684 9.03992 12.0617 9.03992C12.3817 9.03992 12.6684 9.17325 12.9217 9.43992L15.5817 12.3599L18.2417 9.43992C18.4951 9.17325 18.7817 9.03992 19.1017 9.03992C19.4084 9.03992 19.6684 9.15325 19.8817 9.37992C20.1084 9.59325 20.2217 9.85325 20.2217 10.1599C20.2217 10.4666 20.1017 10.7399 19.8617 10.9799L17.1017 13.9799L20.0417 17.1599Z" fill="currentColor"/>
                    </svg> -->
                  </div>
                  <div class="settings__item__value">
                    Video FX
                  </div>
                  <div class="settings__item__state">
                    ${videoFx || 'None'}
                  </div>
                </div>

                <div class="settings__item ${lowPassMode ? 'settings__item--enabled' : ''}">
                  <div class="settings__item__icon">
                    <!-- <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M18 20.5C18.8284 20.5 19.5 19.8284 19.5 19C19.5 18.9725 19.5 18.9447 19.5 18.9166C19.5004 17.9692 19.5008 16.6719 19.1175 15.4613C18.6909 14.1138 17.7955 12.874 16.106 12.1279C14.5529 11.4419 13.3469 11.427 12.2717 11.6064C11.9589 11.6586 11.6087 11.7383 11.3213 11.8037C11.1972 11.832 11.0849 11.8575 10.9923 11.8771C10.6299 11.9536 10.3219 12 10 12C9.46998 12 8.7328 11.5142 7.92374 10.1658C7.18355 8.93211 6.67782 7.45113 6.44715 6.60532C6.22917 5.80609 5.40456 5.33488 4.60533 5.55285C3.80609 5.77083 3.33488 6.59544 3.55286 7.39468C3.82218 8.3822 4.41645 10.1512 5.35126 11.7092C6.2172 13.1525 7.73003 15 10 15C10.6195 15 11.1572 14.9084 11.612 14.8124C11.8098 14.7706 11.9706 14.7336 12.1154 14.7003C12.3441 14.6477 12.5332 14.6042 12.7654 14.5655C13.3445 14.4689 13.9471 14.4539 14.894 14.8721C15.7045 15.2301 16.0591 15.7403 16.2575 16.3668C16.4878 17.0942 16.5 17.9537 16.5 19C16.5 19.8284 17.1716 20.5 18 20.5Z" fill="currentColor"/>
                    </svg> -->
                  </div>
                  <div class="settings__item__value">
                    Low Pass Mode
                  </div>
                  <div class="settings__item__state">
                    ${lowPassMode ? 'Enabled' : 'Disabled'}
                  </div>
                </div>

                <div class="settings__item ${lofiTapeMode ? 'settings__item--enabled' : ''}">
                  <div class="settings__item__icon">
                    <!-- <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9022 18.2317C15.8185 18.1997 15.5833 18.0781 15.1714 17.5631C14.8413 17.1505 14.5908 16.8246 14.3715 16.5393C14.2604 16.3947 14.1573 16.2606 14.056 16.131C13.7912 15.7921 13.4942 15.4228 13.1445 15.1423C12.3296 14.4888 11.4278 14.4945 10.6827 14.4993C10.6207 14.4997 10.5597 14.5001 10.5 14.5001C10.3087 14.5001 10.2202 14.4707 10.1931 14.4601C10.1703 14.4511 10.1564 14.4425 10.1338 14.421C10.1002 14.389 10.0562 14.3374 9.96672 14.2109C9.95877 14.1996 9.94872 14.1851 9.93683 14.168C9.86209 14.0603 9.71455 13.8477 9.55706 13.6754C9.34317 13.4414 8.99003 13.1357 8.45962 13.0053C7.93571 12.8765 7.44674 12.9695 7.04833 13.1189C6.32779 13.3891 5.50831 13.9996 4.51224 14.8711C3.88879 15.4166 3.82561 16.3643 4.37113 16.9877C4.91665 17.6112 5.86429 17.6744 6.48775 17.1289C7.0381 16.6473 7.42364 16.3502 7.68513 16.1705C7.78645 16.3007 7.91308 16.4491 8.06624 16.5948C8.64244 17.1428 9.429 17.5001 10.5 17.5001C10.9774 17.5001 11.1814 17.5034 11.3068 17.5184C11.364 17.5752 11.4738 17.6987 11.6923 17.9784C11.7697 18.0774 11.8604 18.1954 11.9639 18.33C12.1923 18.6269 12.4827 19.0046 12.8286 19.4371C13.4167 20.1722 14.0565 20.7382 14.8321 21.0343C15.6326 21.34 16.3738 21.2801 16.9818 21.1585C17.4077 21.0733 17.7643 20.9731 18.1065 20.8769C18.8069 20.68 19.4473 20.5 20.5 20.5C21.3284 20.5 22 19.8284 22 19C22 18.1716 21.3284 17.5 20.5 17.5C19.0019 17.5 17.7058 17.8612 16.9298 18.0775C16.7045 18.1402 16.5231 18.1908 16.3932 18.2168C16.0637 18.2827 15.9611 18.2542 15.9022 18.2317Z" fill="currentColor"/>
                    </svg> -->
                  </div>
                  <div class="settings__item__value">
                    Lofi Tape Mode
                  </div>
                  <div class="settings__item__state">
                    ${lofiTapeMode ? 'Enabled' : 'Disabled'}
                  </div>
                </div>
              </div>

              <a class="install-cta" href="/install">
                <div class="install-cta__button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle><line x1="21.17" y1="8" x2="12" y2="8"></line><line x1="3.95" y1="6.06" x2="8.54" y2="14"></line><line x1="10.88" y1="21.94" x2="15.46" y2="14"></line></svg><span>Install extension</span></div>  
                <div class="install-cta__text">You can explore your moods from your favorite songs too with Slowed.</div>
              </a>
            </div>

            ${player}

            <div class="end-bar"></div>
          </div>
        </div>
      </div>
    `
  }

  document.getElementById('content').innerHTML = html

  if (audio) {
    document.getElementById('play').addEventListener('click', playAudio)
  }
}

async function renderMetatags (state) {
  const {
    youtubeImageUrl, youtubeTrackName, url, mediaId
  } = state

  if (mediaId) {
    const parsedUrl = new URL(url)
    const urlParams = new URLSearchParams(parsedUrl.search.slice(1))
    urlParams.set('embeded', 'true')
    parsedUrl.search = urlParams.toString()
    const embededUrl = parsedUrl.toString()

    upsertMetatag('video_height', '120')
    upsertMetatag('video_width', '400')
    upsertMetatag('video_type', 'application/x-shockwave-flash')

    upsertMetatag('og:video', embededUrl)
    upsertMetatag('og:video:secure_url', embededUrl)
    upsertMetatag('og:video:type', 'text/html')
    upsertMetatag('og:video:height', '120')
    upsertMetatag('og:video:width', '400')

    upsertMetatag('music:preview_url:url', embededUrl)
    upsertMetatag('music:preview_url:secure_url', embededUrl)
    upsertMetatag('music:preview_url:type', 'audio/wav')

    upsertMetatag('twitter:card', 'player')
    upsertMetatag('twitter:player', embededUrl)
    upsertMetatag('twitter:player:height', '200')
    upsertMetatag('twitter:player:width', '200')
  }

  upsertMetatag('og:site_name', 'Slowed')
  upsertMetatag('og:url', url)
  upsertMetatag('og:type', 'video.other')
  upsertMetatag('og:title', youtubeTrackName)
  upsertMetatag('og:description', 'Now available at the Chrome Web Store')
  upsertMetatag('og:image', youtubeImageUrl)
  upsertMetatag('og:image:width', '128')
  upsertMetatag('og:image:height', '128')
}

export async function init () {
  localStorage.setItem('lastShareUrlSeen', window.location.href)

  try {
    const url = window.location.href
    const { search } = new URL(url)
    const { embeded, autoplay } = search ? getQueryParams(search) : {}

    const {
      url: youtubeUrl, trackName: youtubeTrackName, slowControl,
      reverbMode, lowPassMode, lofiTapeMode, mediaId, videoFx
    } = decodeStateFromUrl(url)

    const { search: youtubeUrlSearch } = new URL(youtubeUrl)
    const { v: youtubeV } = youtubeUrlSearch ? getQueryParams(youtubeUrlSearch) : {}
    const youtubeImageUrl = `http://img.youtube.com/vi/${youtubeV}/maxresdefault.jpg`
    const mediaUrl = mediaId ? `https://media.slowed.app/${mediaId}` : null
    const audio = mediaUrl ? new Audio(mediaUrl) : null

    const playAudio = () => {
      if (!audio.paused) {
        audio.pause()
        if (audio.__fadeInAnimation) audio.__fadeInAnimation.stop()
        if (audio.__fadeOutAnimation) audio.__fadeOutAnimation.stop()
        if (audio.__fadeOutTimeout) clearTimeout(audio.__fadeOutTimeout)
        audio.currentTime = 0
      } else {
        audio.volume = 0
        audio.play()
        audio.__fadeInAnimation = animate({
          from: 0,
          to: 1,
          duration: 2000,
          ease: easeIn,
          onUpdate: (value) => audio.volume = value
        })

        audio.__fadeOutTimeout = setTimeout(() => audio.__fadeOutAnimation = animate({
          from: 1,
          to: 0,
          duration: 2000,
          ease: easeOut,
          onUpdate: (value) => audio.volume = value
        }), 8000)
      }

      render(state)
    }

    const state = {
      youtubeUrl,
      youtubeTrackName,
      youtubeV,
      youtubeImageUrl,
      slowControl,
      reverbMode,
      lowPassMode,
      lofiTapeMode,
      mediaId,
      videoFx,
      audio,
      url,
      mediaUrl,
      embeded,
      playAudio
    }

    if (audio) {
      audio.addEventListener('ended', () => render(state))
    }

    await renderMetatags(state)
    await render(state)
    if (autoplay) playAudio()
  } catch (error) {
    console.error(error)
    await render({ error })
  }
}
